import Spline from '@splinetool/react-spline';

const SignInSpline = (props) => {
  return (
    <Spline scene="https://prod.spline.design/FNK1eJqeAAJAROIO/scene.splinecode" />
  );
}

export default SignInSpline;